import React from "react";
import { useIsFirstTimeVisitNotificationPanel } from "./hooks";
import { StyledBadge } from "./styles";
export const DashboardBadge = ({
  children
}) => {
  const {
    isFirstTime
  } = useIsFirstTimeVisitNotificationPanel();
  return /*#__PURE__*/React.createElement(StyledBadge, {
    invisible: !isFirstTime,
    variant: "dot",
    "data-qa": "dashboard-badge"
  }, children);
};